// TODO : add enum for activity type

// magic suggestion from the api
export interface IMagicSuggestionActivityType {
  id: number;
  title: string;
  description: string;
  img: string;
  steps: string[];
}

export interface IBlankActivityType {
  id: number;
  title: string;
  description: string;
  img: string;
  steps: string[];
}

// activity context type
// activity can be a magic suggestion or a blank activity (from the activity library)
// this how we  store activity  it in the context
// how we know which one it is? we have a type property
export interface ISelectedActivityContextType {
  type: string;
  activity: IMagicSuggestionActivityType | IBlankActivityType;
}

export interface IActivityContextPropsType {
  // null in case no activity is selected (e.g. when the app is first loaded)
  selectedActivity: ISelectedActivityContextType | null;
}

export enum ActivityTypeEnum {
  SITUATIONAL = 'SITUATIONAL',
  ONETIME = 'ONETIME',
  RECCURENT = 'RECCURENT',
}

export enum ActivityTypeWithAllEnum {
  ALL = 'ALL',
  SITUATIONAL = 'SITUATIONAL',
  ONETIME = 'ONETIME',
  RECCURENT = 'RECCURENT',
}

export const activityTypeOptions = [
  {
    label: 'activity.activityTable.oneTime',
    value: ActivityTypeEnum.ONETIME,
  },
  {
    label: 'activity.activityTable.repetitive',
    value: ActivityTypeEnum.RECCURENT,
  },
  {
    label: 'activity.activityTable.custom',
    value: ActivityTypeEnum.SITUATIONAL,
  },
];

export const activityTypeOptionsWithAll = [
  {
    label: 'activity.activityTable.all',
    value: ActivityTypeWithAllEnum.ALL,
  },
  {
    label: 'activity.activityTable.oneTime',
    value: ActivityTypeWithAllEnum.ONETIME,
  },
  {
    label: 'activity.activityTable.repetitive',
    value: ActivityTypeWithAllEnum.RECCURENT,
  },
  {
    label: 'activity.activityTable.custom',
    value: ActivityTypeWithAllEnum.SITUATIONAL,
  },
];

export enum AdvanceActivityStepType {
  BOOLEAN = 'BOOLEAN',
  ANY = 'ANY',
  NUMBER = 'NUMBER',
  PERCENTAGE = 'PERCENTAGE',
  SELECTION = 'SELECTION',
}

export const advanceActivityStepTypes = [
  { value: 'BOOLEAN', label: 'activity.assignActivity.boolean' },
  { value: 'ANY', label: 'activity.assignActivity.any' },
  { value: 'NUMBER', label: 'activity.assignActivity.number' },
  { value: 'PERCENTAGE', label: 'activity.assignActivity.percentage' },
  { value: 'SELECTION', label: 'activity.assignActivity.selection' },
];
